var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyGoStayLogoNew = function SvgHappyGoStayLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 59 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__a)",
    fillRule: "evenodd",
    d: "M16.75 11a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5m1.834-5.723.212-.805h-.828a1.8 1.8 0 0 0-.267-.714h.887l.216-.801h-3.885l-.245.975h1.08q.364 0 .585.129a.74.74 0 0 1 .345.41h-1.798l-.216.806h2.039a1 1 0 0 1-.06.154.83.83 0 0 1-.327.357 1.07 1.07 0 0 1-.56.132h-.976l.005.71 2 2.37h1.361v-.058l-1.8-2.17q.588-.105.95-.358.36-.257.527-.651.093-.223.134-.486z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__b)",
    fillRule: "evenodd",
    d: "M7.384 5.757v-.746q0-.893-.526-1.523t-1.366-.631q-.96 0-1.509.755t-.548 2.127q0 1.179.52 1.864.522.686 1.427.686.895 0 1.45-.695.552-.695.552-1.837m2.853 3.452q0 2.625-1.509 4.065t-4.37 1.441q-1.892 0-2.999-.543v-2.45q1.444.849 2.917.848 1.462 0 2.267-.778t.805-2.113v-.746H7.31q-.987 1.584-2.916 1.584-1.792 0-2.844-1.27Q.501 7.974.5 5.838q0-2.394 1.17-3.802Q2.84.627 4.751.627q1.71 0 2.56 1.327h.037V.858h2.889z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__c)",
    d: "M24.037 9.513V7.57a3.7 3.7 0 0 0 1.145.665q.619.22 1.25.22.369 0 .645-.067t.46-.184a.8.8 0 0 0 .276-.28.757.757 0 0 0-.054-.804 1.6 1.6 0 0 0-.396-.37 4 4 0 0 0-.597-.327q-.345-.159-.746-.321Q25 5.677 24.5 5.065t-.5-1.48q0-.679.273-1.169.273-.487.743-.804a3.3 3.3 0 0 1 1.088-.463q.62-.15 1.31-.149.68 0 1.204.081.525.082.967.252v1.816a2.7 2.7 0 0 0-.477-.267 4.023 4.023 0 0 0-1.585-.341q-.334.001-.607.065a1.6 1.6 0 0 0-.46.179.9.9 0 0 0-.292.276.65.65 0 0 0-.103.36q0 .218.115.391.116.173.327.329.212.154.516.303.303.149.686.308.52.218.936.463.414.247.712.555.297.31.455.707.157.396.157.926 0 .728-.275 1.222-.275.495-.749.8a3.2 3.2 0 0 1-1.1.441q-.627.135-1.324.134-.715 0-1.36-.121a4.1 4.1 0 0 1-1.12-.366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__d)",
    d: "M37.13 2.74h-2.48v7.106h-1.965V2.74h-2.467V1.144h6.912z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__e)",
    fillRule: "evenodd",
    d: "M43.45 9.847h2.134l-3.09-8.703h-2.322l-3.166 8.703h2.121l.613-1.936h3.092zm-1.068-3.444L41.45 3.48a3.7 3.7 0 0 1-.146-.783h-.048q-.03.382-.152.759l-.947 2.948z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__f)",
    d: "M52.851 1.144 50.02 6.752v3.095h-1.96v-3.06l-2.757-5.644h2.238l1.4 3.247q.036.091.201.71h.024q.08-.437.189-.686l1.424-3.27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayLogoNew_svg__g)",
    d: "M53.072 9.513V7.57a3.8 3.8 0 0 0 1.147.665q.617.22 1.249.22.37 0 .645-.067.276-.067.46-.184a.8.8 0 0 0 .276-.28.7.7 0 0 0 .091-.348q0-.255-.145-.456a1.6 1.6 0 0 0-.398-.37 4 4 0 0 0-.598-.327 16 16 0 0 0-.745-.321q-1.019-.426-1.518-1.038t-.5-1.48q0-.679.272-1.169.274-.487.743-.804.47-.315 1.087-.463.618-.15 1.31-.149.677 0 1.203.081.525.082.967.252v1.816a2.8 2.8 0 0 0-.475-.267 3.95 3.95 0 0 0-1.585-.341q-.335.001-.608.065-.271.064-.46.179a.9.9 0 0 0-.29.276.65.65 0 0 0-.105.36q0 .218.117.391.113.173.327.329.213.154.515.303.304.149.685.308.522.218.937.463.415.247.712.555.299.31.454.707.157.396.158.926 0 .728-.274 1.222a2.24 2.24 0 0 1-.75.8 3.2 3.2 0 0 1-1.101.441q-.627.135-1.324.134-.715 0-1.36-.121a4.1 4.1 0 0 1-1.119-.366"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__a",
    x1: 27.25,
    x2: 16.75,
    y1: 5.75,
    y2: -4.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__b",
    x1: 15.105,
    x2: 1.927,
    y1: 7.672,
    y2: -1.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__c",
    x1: 32.948,
    x2: 24.659,
    y1: 5.5,
    y2: 0.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__d",
    x1: 40.586,
    x2: 32.109,
    y1: 5.495,
    y2: -1.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__e",
    x1: 49.873,
    x2: 41.172,
    y1: 5.495,
    y2: -3.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__f",
    x1: 56.626,
    x2: 48.01,
    y1: 5.495,
    y2: -1.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayLogoNew_svg__g",
    x1: 61.982,
    x2: 53.694,
    y1: 5.5,
    y2: 0.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })))));
};
export default SvgHappyGoStayLogoNew;